import React from 'react';
import { openLearning360Asset, openURLAsset } from 'components/general/assets';
import { useSelector } from 'react-redux';
import { StringHelpers, SystemText } from 'e4shared';
import posthog from 'posthog-js';

export const MandatoryAssets = ({ assets, extraMessage }) => {
    const user = useSelector(state => state.user.user);

    const learningClick = (a, accelerate) => {
        posthog.capture(
            'launched-learning',
            {
                course: a.name,
                course_status: a.completion?.status ? a.completion.status : 'unknown',
            },
            { transport: 'sendBeacon' }
        );

        openURLAsset(a, accelerate);
    };

    return (
        <div>
            {assets.map(a => {
                const accelerate = a.source === 'accelerate';
                const l360 = a.source === 'learning360';
                const completion = a.completion || {};
                let stub = 'NotStarted';
                let css = 'grey';
                let icon = 'circle-xmark';

                if (accelerate) {
                    if (completion.status === 'in_progress') {
                        stub = 'InProgress';
                        css = 'warning';
                        icon = 'hourglass';
                    } else if (completion.status === 'completed') {
                        stub = 'Completed';
                        css = 'success';
                        icon = 'check-circle';
                    }
                } else {
                    if (completion.completed_At) stub = 'Completed';
                    if (!completion.completed_At && completion.started_At) stub = 'InProgress';
                    if (completion.completed_At) css = 'success';
                    if (!completion.completed_At && completion.started_At) css = 'warning';
                    if (completion.completed_At) icon = 'check-circle';
                    if (!completion.completed_At && completion.started_At) icon = 'hourglass';
                }

                return (
                    <div className="flex lms-asset" key={`asset-${a.id}`}>
                        <div className="flex-grow">
                            <div className="">
                                <label className={`label label-${css}`}>
                                    <i className={`fa fa-${icon} mr5`} />
                                    {SystemText(`Objective/MandatoryAssets/${stub}/Label`)}
                                </label>
                            </div>
                            <h4>{a.name}</h4>
                            <div className="">
                                <span className="text-grey">
                                    {a.description}
                                    {a.description && a.duration > 0 && <span className="mr5 ml5">|</span>}
                                    {a.duration > 0 && (
                                        <>
                                            <i className="fa fa-clock mr5" />
                                            {StringHelpers.displayMinutes(a.duration / 60)}
                                        </>
                                    )}
                                </span>
                            </div>
                        </div>
                        <div>
                            <button
                                className="btn btn-primary"
                                onClick={() => (l360 ? openLearning360Asset(a, user) : learningClick(a, accelerate))}
                            >
                                {SystemText(`Objective/MandatoryAssets/${stub}/Button`)}
                            </button>
                        </div>
                    </div>
                );
            })}
            {extraMessage && <div className="mt20 text-sm">{extraMessage}</div>}
        </div>
    );
};

export default MandatoryAssets;
